import appApi from '../../../../../api/app-api';
import { GeneralAttendanceSideBarFilterDataModel } from '../side-bar-filter/general-attendance-side-bar-filter-data-model';
import { ReportGeneralAttendanceType } from '../../../../../api/types/reports/education/report-general-attendance.type';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

export const generalAttendanceOperations = async (
  filters: GeneralAttendanceSideBarFilterDataModel,
  setLoading: (loading: boolean) => any,
  setData: (data: ReportGeneralAttendanceType[]) => any,
) => {
  try {
    setLoading(true);
    const res = await appApi.getGeneralAttendanceReport(filters);
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return;
    }
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
  }
};
